/**
 * Magnitude across a handful of named categories.
 *
 * <p>One hue, because the job is comparing sizes rather than telling identities apart —
 * a categorical palette here would spend five colours to say nothing the labels do not
 * already say, and would bury whichever bar actually matters.
 *
 * <p>Every category is drawn even at zero: a breakdown that hides empty rows changes
 * shape as data arrives, and "no rejected teachers" is worth seeing.
 */
export default function BarRows({ slices, emptyMessage = 'Nothing to show yet.' }) {
  const max = Math.max(1, ...slices.map((slice) => slice.value));
  const total = slices.reduce((sum, slice) => sum + slice.value, 0);

  if (total === 0) {
    return <p className="muted small" style={{ margin: 0 }}>{emptyMessage}</p>;
  }

  return (
    <div className="bar-rows">
      {slices.map((slice) => (
        <div className="bar-row" key={slice.key}>
          <span>{slice.label}</span>
          <span className="bar-track">
            <span
              className="bar-fill"
              style={{ width: `${Math.max(1, (slice.value / max) * 100)}%` }}
              // Decoration over the number beside it, which every reader gets whether
              // or not they can see the fill.
              aria-hidden="true"
            />
          </span>
          <span className="bar-value">{slice.value.toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}
